$color-info: #285172;
$color-success: #bbd03a;
$color-warning: #ff9302;
$color-error: #ff0201;
$color-disabled: #a1a1a1;

:host {
    --ux-tag-border: transparent;
    --ux-tag-outline-hover: none;
    --ux-tag-border-color-hover: transparent;
    --ux-tag-font-weight: bold;
    --ux-tag-letter-spacing: 0;

    display: inline-block;
    box-sizing: border-box;

    ux-tag {
        box-sizing: border-box;
        margin: 0;
    }
}

:host([status="info"]) {
    --ux-tag-background-color: #{$color-info};
    --ux-tag-background-color-hover: #{$color-info};
}

:host([status="success"]) {
    --ux-tag-background-color: #{$color-success};
    --ux-tag-background-color-hover: #{$color-success};
}

:host([status="warning"]) {
    --ux-tag-background-color: #{$color-warning};
    --ux-tag-background-color-hover: #{$color-warning};
}

:host([status="error"]) {
    --ux-tag-background-color: #{$color-error};
    --ux-tag-background-color-hover: #{$color-error};
}

:host([status="disabled"]) {
    --ux-tag-background-color: #{$color-disabled};
    --ux-tag-background-color-hover: #{$color-disabled};
}
